import React from 'react';
import Link from '../Link';
import Image from '../Image';

import './BannerImage.module.scss';

class BannerImage extends React.PureComponent {
  render() {
    const { name, link, imageSrc } = this.props;

    return (
      <div styleName="banner-image">
        <Link href={link} styleName="link">
          <Image src={imageSrc} styleName="image" name={name} />
        </Link>
      </div>
    );
  }
}

export default BannerImage;



// WEBPACK FOOTER //
// ./src/js/widgets/Banner/BannerImage.js